import { render } from "./inventorySetMenu.vue?vue&type=template&id=ae03bc14&scoped=true"
import script from "./inventorySetMenu.vue?vue&type=script&lang=js"
export * from "./inventorySetMenu.vue?vue&type=script&lang=js"

import "./inventorySetMenu.vue?vue&type=style&index=0&id=ae03bc14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae03bc14"

export default script